// 'styles' folder is reserved for reusable styled-components
// @ts-ignore
import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const pageTitle = css`
  display: block;
  position: absolute;
  width: 1px;
  height: 1px;
  top: -99999px;
  left: -99999px;
`;

export const InfoSection = css`
  max-width: 860px;
  margin: 0 auto;
  ${mediaQuery(
    {
      min: minBreakpoints.M,
    },
    css`
      margin-top: ${pxToRem(spacing.lg)};
    `,
  )}
`;

export const CarouselWrapper = css`
  margin: 0 -15px 10px;

  .slick-track {
    left: 10px;
  }
  ${mediaQuery(
    {
      min: minBreakpoints.M,
    },
    css`
      margin: 0 -10px;

      .slick-track {
        left: 0px;
      }
    `,
  )}
`;

export const HeroCtaWrapper = css`
  margin: 0 -5px;
  ${mediaQuery(
    {
      min: minBreakpoints.M,
    },
    css`
      margin: 0 -10px;
    `,
  )}
`;
